export default "__VITE_ASSET__BLjrXaG8__"